// extracted by mini-css-extract-plugin
export var dataCell = "_m5-2";
export var dataRow = "_m5-0";
export var headerRow = "_m5-1";